import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { SettingsFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { RemoveEmployeeFormContainerProps } from "models/propTypes/settingsPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import RemoveEmployeeForm from "./removeEmployeeForm";
//#endregion
import { useEmployeeService } from "serviceHooks";
import * as Yup from "yup";

const RemoveEmployeeFormContainer: ForwardRefRenderFunction<FormHandles, RemoveEmployeeFormContainerProps> = (
  props,
  ref
) => {
  const employeeService = useEmployeeService();
  const { name: employeeName, isSalaryActive, id } = props;

  const validationSchema = Yup.object<SettingsFormTypes.RemoveEmployee>({
    employmentEndDate: (isSalaryActive
      ? Yup.date().required(TranslationKeys.Validations.Required)
      : Yup.date()
    ).typeError(TranslationKeys.Validations.InvalidDate),
  });

  const handleSubmit = (value: SettingsFormTypes.RemoveEmployee) => {
    const employeeDeleteExtraData: WintSuperkollAPIModel.EmployeeDeleteExtraData = {
      employmentEndDate: value.employmentEndDate,
    };

    return employeeService.removeEmployee(id, employeeDeleteExtraData);
  };

  return (
    <RemoveEmployeeForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={{}}
      handleSubmit={handleSubmit}
      isSalaryActive={isSalaryActive!}
      employeeName={employeeName}
    />
  );
};

export default forwardRef(RemoveEmployeeFormContainer);
